<template>
    <div class="text-left row mt-5 mb-5">
      <div class="container">


      <div class="col ">
        <h2 style="color: #fff;" class="mb-4">Meu Perfil</h2>
        <div class="form-group">
          <div class="row mt-2">
            <div class=" col-sm-12">
              <label for="campo">Empresa</label>
              <input type="text" v-model="form.descricao" class="form-control">
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12 col-md-6">
              <label for="campo">Login</label>
              <input type="text" @change="loginChanged = true" v-model="form.login" class="form-control ">
            </div>
            <div class=" col">
              <label for="campo">Senha</label>
              <div class="input-group">
                <input :type=" !showPassword ? 'password' : 'text' " v-model="form.password" class="form-control">
                <div class="input-group-append">
                  <span class="input-group-text" @click="showPassword = !showPassword">
                    <font-awesome-icon v-if="!showPassword" icon="eye" />
                    <font-awesome-icon v-if="showPassword" icon="eye-slash" />
                  </span>
                </div>
              </div>
              <small class="info">*Deixe em branco para manter a mesma senha</small>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-12 col-md-6">
              <label for="campo">Email</label>
              <input type="text" v-model="form.email" class="form-control ">
            </div>
            <div class=" col">
              <label for="campo">Telefone</label>
              <the-mask :mask="['(##) ####-####', '(##) #####-####']" v-model="form.telefone" class="form-control" placeholder="Número de celular"/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <my-alert
          class="alert-danger col-sm-12 text-center"
          @done='showError = false'
          :message ='errorMessage'
          :show='showError'
          :timeout="10000"
        ></my-alert>

        <my-alert
          class="alert-success col-sm-12 text-center"
          @done='showSuccess = false'
          :message ='successMessage'
          :show='showSuccess'
        ></my-alert>
      </div>

      <div class="row col-sm-12 mb-4 mt-4">
          <div class="col">
            <button class="btn btn-success col-sm-6 offset-sm-3 mb-4" @click="updateUser()">
              Atualizar meus dados
            </button>
        </div>

      </div>

      </div>


  </div>

</template>

<script>

import jwtDecode from 'jwt-decode';

export default {
  data() {
    return {
      showPassword: false,
      form: {
      },
      selectedMensagem: 0,
      processing: false,
      loginChanged: false,
    }
  },
  methods: {
    async updateUser () {
      let valid = true;
      let loginExists = false
      if (this.loginChanged) {
        const resp = await this.$http.post('/v1/v3/meu-perfil/test-login', { login: this.form.login});
        if (!resp.success) {
          valid = false;
          this.showError = true;
          this.errorMessage = resp.err;
          return;
        }
      }

      if (!this.form.descricao || !this.form.login || !this.form.email || !this.form.telefone) valid = false;

      if (!valid) {
        this.showError = true;
        this.errorMessage = 'Preencha o login, email, empresa e telefone';
        return;
      }

      const resp = await this.$http.put('/v1/v3/meu-perfil', this.form);

      if(resp.success) {
        this.showSuccess = true;
        this.successMessage = 'Dados atualizados';
      } else {
        this.showError = true;
        this.errorMessage = resp.err;
      }

    }
  },
  async mounted() {
    this.decoded = jwtDecode(this.$store.getters.authToken);
    const data  = await this.$http.get('/v1/v3/meu-perfil');
    this.form = data.data;
  },
};
</script>
